'use strict';

var fragt = fragt || {};

fragt.forms = fragt.forms || new function () {
    this.init = function () {

        var forms = document.querySelectorAll('.umbraco-forms-form form');

        if (forms.length > 0) {
            for (var i = 0; i < forms.length; i++) {
                forms[i].addEventListener('submit', submitHandler);
            }
        }
        function submitHandler(e) {
            e.preventDefault();

            var form = e.srcElement;
            var formNameElement = form.querySelector('input[name="FormName"]');
            var formName = (formNameElement && formNameElement.value) ? formNameElement.value : 'Unknown Form';

            form.classList.add('is-loading');

            // Small timeout needed to get validation errors
            setTimeout(function() {
                var errors = form.querySelectorAll('.field-validation-error');
                if (!errors.length) {
                    if (typeof grecaptcha === 'undefined') {
                        alert('Google reCAPTCHA is not available. Please try again later or contact us if the issue persists.');
                        form.classList.remove('is-loading');
                    } else {
                        grecaptcha.ready(function () {
                            grecaptcha.execute('6LddgIoqAAAAAEkXVKhKOO1Y32k8fIbxY0EvPux8', { action: 'submit' }).then(function (token) {
                                var xhttp = new XMLHttpRequest();
                                xhttp.open('POST', '/Umbraco/Api/RecaptchaApi/ValidateRecaptcha', true);
                                xhttp.setRequestHeader('Content-Type', 'application/json');
                                xhttp.onreadystatechange = function () {
                                    // When the form is submitted, the page reloads even when the form is configured to just show a message.
                                    // So we only need to remove the loading state manually when an error occurs
                                    if (this.readyState == 4) {
                                        if (this.status === 200) {
                                            try {
                                                var response = JSON.parse(this.responseText);
                                                if (response.Success) {
                                                    form.submit();
                                                } else {
                                                    form.classList.remove('is-loading');
                                                    alert('An unknown error occurred. Please try again later or contact us if the issue persists.');
                                                }
                                            } catch (error) {
                                                form.classList.remove('is-loading');
                                                alert('An error occurred while validating your request. Please try again later or contact us if the issue persists.');
                                            }
                                        } else {
                                            form.classList.remove('is-loading');
                                            alert('The server responded with an error code ' + this.status + '. Please try again later or contact us if the issue persists.');
                                        }
                                    }
                                };
                                xhttp.send(JSON.stringify({
                                    RecaptchaResponse: token,
                                    FormName: formName
                                }));
                            });
                        });
                    }
                } else {
                    form.classList.remove('is-loading');
                }
            }, 200);


        }
    };
}();
